<template>
	<div class="job-detail-container">
		<div class="job-detail-content">
			<!-- 职位信息卡片--start -->
			<div class="job-card">
				<!-- 顶部状态标签 -->
				<div class="job-status-tag">招聘中</div>

				<!-- 职位信息和福利标签区域 -->
				<div class="job-info-welfare-wrapper">
					<!-- 左侧职位信息 -->
					<div class="job-info-block">
						<!-- 职位标题和薪资 -->
						<div class="job-title-box">
							<div class="job-title">PMC注册安全工程师</div>
							<div class="job-salary">15K~20K/月</div>
						</div>

						<!-- 职位基本信息 -->
						<div class="job-basic-info">
							<div class="info-item">
								<svg-icon icon-class="location"></svg-icon>
								<span>武汉·洪山区</span>
							</div>
							<div class="info-item">
								<svg-icon icon-class="location"></svg-icon>
								<span>3-5年</span>
							</div>
							<div class="info-item">
								<svg-icon icon-class="location"></svg-icon>
								<span>大专</span>
							</div>
						</div>
					</div>

					<!-- 右侧福利标签 -->
					<div class="job-welfare-section">
						<span class="welfare-tag">五险一金</span>
						<span class="welfare-tag">交通补助</span>
						<span class="welfare-tag">节日福利</span>
						<span class="welfare-tag">定期体检</span>
						<span class="welfare-tag">...</span>
					</div>
				</div>

				<!-- 操作按钮区域 -->
				<div class="job-action-section">
					<div class="action-left">
						<button class="btn-collect" type="button">
							<svg-icon icon-class="collect"></svg-icon>
							收藏
						</button>
						<button class="btn-apply" type="button">
							<svg-icon icon-class="deliver"></svg-icon>
							投递
						</button>
					</div>
					<div class="action-right">
						<div class="resume-item">
							<svg-icon icon-class="location"></svg-icon>
							<span>填写在线简历</span>
						</div>
						<div class="resume-item">
							<svg-icon icon-class="location"></svg-icon>
							<span>上传附件简历</span>
						</div>
						<div class="resume-item">
							<svg-icon icon-class="location"></svg-icon>
							<span>更新时间：2025-03-18</span>
						</div>
					</div>
				</div>
			</div>
			<!-- 职位信息卡片--end -->

			<div class="section-detail-wrapper">
				<!-- 左侧信息 -->
				<div class="section-detail-left">
					<div class="section-detail">
						<!-- 职位描述 -->
						<div class="section-dot-title loose">职位描述</div>
						<div class="section-info">
							<div class="info-row">
								<div class="info-item">
									<span class="info-label">职位：</span>
									<span class="info-value">安全员/安全工程师，专业监理工程师</span>
								</div>
								<div class="info-item">
									<span class="info-label">招聘类型：</span>
									<span class="info-value">全职招聘</span>
								</div>
							</div>
							<div class="info-row">
								<div class="info-item">
									<span class="info-label">专业要求：</span>
									<span class="info-value">2001-02-24</span>
								</div>
							</div>
						</div>

						<!-- 求职意向 -->
						<div class="section-dot-title loose">求职意向</div>
						<div class="section-info">
							<div class="info-row">
								<div class="info-item">
									<span class="info-label">求职类型：</span>
									<span class="info-value">全职/兼职</span>
								</div>
								<div class="info-item">
									<span class="info-label">期望职位：</span>
									<span class="info-value">xx/xx/xx</span>
								</div>
							</div>
							<div class="info-row">
								<div class="info-item">
									<span class="info-label">就业地区：</span>
									<span class="info-value">xxxxxxxxxxxx</span>
								</div>
								<div class="info-item">
									<span class="info-label">招聘人数：</span>
									<span class="info-value">5人</span>
								</div>
							</div>
							<div class="info-row">
								<div class="info-item">
									<span class="info-label">职称要求：</span>
									<span class="info-value">无</span>
								</div>
								<div class="info-item">
									<span class="info-label">证书要求：</span>
									<span class="info-value">中级注册安全工程师</span>
								</div>
							</div>
						</div>

						<!-- 岗位职责 -->
						<div class="section-dot-title loose">岗位职责</div>
						<div class="section-info">
							<p>1.PMC注册安全工程师（东北、北方）；</p>
							<p>2.持证：具有注册安全工程师资格证（初始或转注册），注册专业为化工安全、建筑施工安全及其他安全。</p>
							<p>3.学历：大专及以上，中级职称优先；</p>
							<p>4.工作经验：必须具备石油化工（煤化工类也可）一年及以上工作经验；</p>
							<p>
								5.其他：年龄52岁及以下，男女不限。公司提供食宿、团建活动、社会保险、商业保险、带薪休假、休假差旅费用报销、节假日福利金等。
							</p>
						</div>

						<!-- 公司简介 -->
						<div class="section-dot-title loose">公司简介</div>
						<div class="section-info">
							<p>输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字</p>
						</div>

						<!-- 办公地址 -->
						<div class="section-dot-title loose">办公地址</div>
						<div class="section-info">
							<p>输入一段文字输入一段文字输入一段文字输入一段文字</p>
						</div>

						<!-- 其他职位 -->
						<div class="section-dot-title loose">其他职位</div>
						<div class="position-content">
							<div class="position-list-other">
								<div class="position-item">
									<h3 class="position-title">PMC注册安全工程师</h3>
									<div class="position-meta">
										<span class="position-salary">15K~20K</span>
										<span class="position-location">武汉-洪山区</span>
										<span class="position-education">本科</span>
										<span class="position-experience">3~5年</span>
									</div>
								</div>

								<div class="position-item">
									<h3 class="position-title">PMC注册安全工程师</h3>
									<div class="position-meta">
										<span class="position-salary">15K~20K</span>
										<span class="position-location">武汉-洪山区</span>
										<span class="position-education">本科</span>
										<span class="position-experience">3~5年</span>
									</div>
								</div>

								<div class="position-item">
									<h3 class="position-title">PMC注册安全工程师</h3>
									<div class="position-meta">
										<span class="position-salary">15K~20K</span>
										<span class="position-location">武汉-洪山区</span>
										<span class="position-education">本科</span>
										<span class="position-experience">3~5年</span>
									</div>
								</div>

								<div class="position-item">
									<h3 class="position-title">PMC注册安全工程师</h3>
									<div class="position-meta">
										<span class="position-salary">15K~20K</span>
										<span class="position-location">武汉-洪山区</span>
										<span class="position-education">本科</span>
										<span class="position-experience">3~5年</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- 右侧信息 -->
				<div class="section-detail-right">
					<!-- 公司基本信息--start -->
					<div class="company-info-card">
						<div class="section-simple-title">
							<h4>公司基本信息</h4>
						</div>

						<div class="company-info-content">
							<div class="company-logo">
								<img src="@/assets/employment/companyLogo.png" alt="公司logo" />
							</div>
							<div class="company-name">中华华力建设集团有限公司</div>
							<div class="company-info-item">
								<span class="info-label">性质：</span>
								<span class="info-value">国有企业</span>
							</div>
							<div class="company-info-item">
								<span class="info-label">行业：</span>
								<span class="info-value">建筑</span>
							</div>
							<div class="company-info-item">
								<span class="info-label">规模：</span>
								<span class="info-value">499人</span>
							</div>
							<div class="company-info-item">
								<span class="info-label">地区：</span>
								<span class="info-value">武汉市-洪山区</span>
							</div>
							<div class="company-info-item">
								<span class="info-label">联系方式：</span>
								<span class="info-value">027-65899087</span>
							</div>
							<div class="company-more">
								<a href="javascript:;">查看详情 >></a>
							</div>
						</div>
					</div>
					<!-- 公司基本信息--end -->

					<!-- 公司其他职位--start -->
					<div class="company-jobs-card">
						<div class="section-simple-title">
							<h4>公司其他职位</h4>
						</div>

						<div class="company-jobs-list">
							<div class="job-item">
								<div class="job-name">PMC注册安全工程师</div>
								<div class="job-salary">15K~20K/月</div>
								<div class="job-tags">
									<span class="job-tag">武汉-洪山区</span>
									<span class="job-tag">本科</span>
									<span class="job-tag">3~5年</span>
								</div>
							</div>

							<div class="job-item">
								<div class="job-name">PMC注册安全工程师</div>
								<div class="job-salary">15K~20K/月</div>
								<div class="job-tags">
									<span class="job-tag">武汉-洪山区</span>
									<span class="job-tag">本科</span>
									<span class="job-tag">3~5年</span>
								</div>
							</div>

							<div class="job-item">
								<div class="job-name">PMC注册安全工程师</div>
								<div class="job-salary">15K~20K/月</div>
								<div class="job-tags">
									<span class="job-tag">武汉-洪山区</span>
									<span class="job-tag">本科</span>
									<span class="job-tag">3~5年</span>
								</div>
							</div>

							<div class="job-item">
								<div class="job-name">PMC注册安全工程师</div>
								<div class="job-salary">15K~20K/月</div>
								<div class="job-tags">
									<span class="job-tag">武汉-洪山区</span>
									<span class="job-tag">本科</span>
									<span class="job-tag">3~5年</span>
								</div>
							</div>

							<!-- 查看更多按钮 -->
							<button class="view-more-btn" type="button">查看更多</button>
						</div>
					</div>
					<!-- 公司其他职位--end -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	// 岗位详情
	export default {
		name: 'JobDetail',
		components: {},
		props: {},
		data() {
			return {}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/employment.scss';

	.job-detail-container {
		background-color: #eff6f9;
		padding: 20px 0;
		.job-detail-content {
			width: $main-page-width;
			margin: 0 auto;

			// 职位信息卡片
			.job-card {
				position: relative;
				background-color: #fff;
				padding: 20px;
				margin-bottom: 20px;

				/* 顶部状态标签 */
				.job-status-tag {
					position: absolute;
					top: 0;
					left: 0;
					background-color: #6caffe;
					color: #fff;
					font-size: 16px;
					padding: 4px 12px;
					border-radius: 0 0 10px 0;
					z-index: 1;
				}

				/* 职位信息和福利标签包装器 */
				.job-info-welfare-wrapper {
					display: flex;
					justify-content: space-between;
					align-items: center;
					padding: 20px 0;

					/* 左侧职位信息块 */
					.job-info-block {
						flex: 1;
						margin-right: 20px;

						.job-title-box {
							display: flex;
							align-items: center;
							margin: 10px 0;

							.job-title {
								font-size: 26px;
								font-weight: bold;
								line-height: 1.5;
								color: #333;
								margin-right: 50px;
							}

							.job-salary {
								min-width: 160px;
								font-size: 28px;
								font-weight: bold;
								color: #ff5013;
							}
						}

						.job-basic-info {
							display: flex;

							.info-item {
								display: flex;
								align-items: center;
								margin-right: 20px;
								color: #999999;
								font-size: 16px;

								.svg-icon {
									margin-right: 5px;
									font-size: 16px;
								}
							}
						}
					}

					/* 右侧福利标签区域 */
					.job-welfare-section {
						display: flex;
						flex-wrap: wrap;
						align-content: flex-start;
						max-width: 40%;

						.welfare-tag {
							background-color: #daeaff;
							color: #1e94f8;
							padding: 4px 12px;
							border-radius: 4px;
							font-size: 16px;

							& + .welfare-tag {
								margin-left: 10px;
							}
						}
					}
				}

				/* 操作按钮区域 */
				.job-action-section {
					display: flex;
					justify-content: space-between;
					align-items: center;
					padding-top: 15px;

					.action-left {
						display: flex;

						button {
							display: flex;
							align-items: center;
							justify-content: center;
							padding: 5px 30px;
							border-radius: 4px;
							font-size: 18px;
							cursor: pointer;

							.svg-icon {
								margin-right: 10px;
							}

							& + button {
								margin-left: 20px;
							}
						}

						.btn-collect {
							background-color: #fff;
							color: #236fca;
							border: 1px solid #236fca;
						}

						.btn-apply {
							background-color: #236fca;
							color: #fff;
							border: none;
						}
					}

					.action-right {
						display: flex;
						align-items: center;

						.resume-item {
							display: flex;
							align-items: center;
							color: #236fca;
							font-size: 18px;

							.svg-icon {
								margin-right: 5px;
								font-size: 18px;
							}

							& + .resume-item {
								margin-left: 15px;
							}
						}
					}
				}
			}

			.section-detail-wrapper {
				.section-detail-right {
					.company-info-card,
					.company-jobs-card {
						background-color: #fff;
						margin-bottom: 20px;
						padding: 20px;
					}

					.company-info-content {
						padding: 20px;
						display: flex;
						flex-direction: column;
						align-items: center;

						.company-logo {
							width: 73px;
							height: 73px;
							margin-bottom: 15px;
							border: solid 1px #daeaff;
							border-radius: 6px;

							img {
								width: 100%;
								height: 100%;
								object-fit: contain;
							}
						}

						.company-name {
							font-size: 16px;
							color: #333;
							margin-bottom: 15px;
							text-align: center;
						}

						.company-info-item {
							width: 100%;
							display: flex;
							margin-bottom: 10px;
							font-size: 14px;
							line-height: 1.5;

							.info-label {
								color: #999999;
								min-width: 70px;
							}

							.info-value {
								color: #999999;
								flex: 1;
							}
						}

						.company-more {
							margin-top: 10px;

							a {
								color: #236fca;
								font-size: 14px;
								text-decoration: none;

								&:hover {
									text-decoration: underline;
								}
							}
						}
					}

					.company-jobs-list {
						min-height: 520px;
						max-height: 520px;
						overflow: hidden;
						position: relative;

						/* 添加蒙层 */
						&::after {
							content: '';
							position: absolute;
							bottom: 0;
							left: 0;
							right: 0;
							height: 90px; /* 蒙层高度，可以根据需要调整 */
							background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.9));
							pointer-events: none; /* 确保蒙层不会阻止点击 */
						}

						/* 查看更多按钮 */
						.view-more-btn {
							position: absolute;
							bottom: 20px;
							left: 50%;
							transform: translateX(-50%);
							z-index: 10;
							background-color: #236fca;
							color: white;
							border: none;
							border-radius: 4px;
							padding: 10px 30px;
							font-size: 16px;
							cursor: pointer;
							box-shadow: 0 2px 8px rgba(37, 153, 251, 0.3);

							&:hover {
								background-color: #1e8ae0;
							}
						}

						.job-item {
							padding: 15px 20px;
							background-color: #f1f7ff;
							border-radius: 6px;

							& + .job-item {
								margin-top: 20px;
							}

							.job-name {
								font-size: 18px;
								font-weight: bold;
								color: #333;
								margin-bottom: 8px;
							}

							.job-salary {
								font-size: 16px;
								color: #ff5013;
								font-weight: bold;
								margin-bottom: 8px;
							}

							.job-tags {
								display: flex;
								flex-wrap: wrap;

								.job-tag {
									background-color: #daeaff;
									color: #1e94f8;
									padding: 2px 8px;
									border-radius: 4px;
									font-size: 14px;

									& + .job-tag {
										margin-left: 10px;
									}
								}
							}
						}
					}
				}
			}
		}
	}
</style>
